import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=fea0262c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=fea0262c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea0262c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fea0262c')) {
      api.createRecord('fea0262c', component.options)
    } else {
      api.reload('fea0262c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=fea0262c&scoped=true&", function () {
      api.rerender('fea0262c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh5mi9b4R3kc/JS/comp/PopupBox.vue"
export default component.exports